module.exports = __webpack_public_path__ + "img/1049e639bab17979fe5999c74e489025.png";